import React, { useState, useEffect } from 'react';
import { CalendarProvider } from './contexts/CalendarContext';
import { SearchProvider } from './contexts/InputSearchContext';
import { SearchDesktop, SearchMobile } from './components';
import { EnvironmentProvider } from './contexts/EnvorimentContext';
const App = ({ environment }) => {
    const [isDesktop, setIsDesktop] = useState(false);
    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 768px)');
        const handleMediaChange = (event) => {
            setIsDesktop(event.matches);
        };
        setIsDesktop(mediaQuery.matches);
        mediaQuery.addEventListener('change', handleMediaChange);
        return () => {
            mediaQuery.removeEventListener('change', handleMediaChange);
        };
    }, []);
    return (React.createElement("div", { className: 'w-full flex justify-center items-center' },
        React.createElement(EnvironmentProvider, { environment: environment },
            React.createElement(SearchProvider, null,
                React.createElement(CalendarProvider, null, isDesktop ? React.createElement(SearchDesktop, { environment: environment }) : React.createElement(SearchMobile, { environment: environment }))))));
};
export default App;
export { App as SViagensFlightSearch, };
//# sourceMappingURL=App.js.map